import { render, staticRenderFns } from "./multipleButtons.vue?vue&type=template&id=2be786fb&scoped=true"
import script from "./multipleButtons.vue?vue&type=script&lang=js"
export * from "./multipleButtons.vue?vue&type=script&lang=js"
import style0 from "./multipleButtons.vue?vue&type=style&index=0&id=2be786fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be786fb",
  null
  
)

export default component.exports